import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../Button';
import CloseIcon from '../../../../../../../icons/CloseIcon';

const propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
};

const CollapsableItem = ({ label, children }) => {
  const [expanded, setExpanded] = useState(false);

  const contentClasses = classNames({
    'marcom-layout-collapsable-item-content': true,
    'marcom-layout-collapsable-item-content-visible': expanded,
  });

  return (
    <div className="marcom-layout-collapsable-item">
      <Button
        btnStyle="reset"
        className="collapsable-item-toggle"
        onClick={() => setExpanded(prev => !prev)}
      >
        {label}{' '}
        {expanded && (
          <CloseIcon size="14px" color="#646e71" className="ml-auto" />
        )}
      </Button>
      <div className={contentClasses}>{children}</div>
    </div>
  );
};

CollapsableItem.propTypes = propTypes;

export default CollapsableItem;
